<template>
  <section>
    <RealtimeAttendancesCount 
      :total="total" 
      :chatbot="chatbot" 
      :aguardando="aguardando" 
      :emAtendimento="emAtendimento" 
      :userChatQueues="userChatQueues"
    />

    <div class="row m-4">
      <div class="col-md-8">
        <TbFilaURA
          @open-modal-transf="handleOpenModalTransf"
          :queues="chatbotQueues"
          :userChatQueues="userChatQueues"
        />
        <TbFilaAtendimento
          @open-modal-transf="handleOpenModalTransf"
          :queues="aguardandoQueues"
          :userChatQueues="userChatQueues"
        />
        <TbFilaAndamento
          @open-modal-transf="handleOpenModalTransf"
          :queues="emAtendimentoQueues"
          :userChatQueues="userChatQueues"
        />

        <ModalTransferencia
          ref="modalTrans"
          :valueClient="dadoClient"
        />
      </div>

      <div class="col-md-4 p-0">
        <TbFilaDetail class="m-2" :userChatQueues="userChatQueues" />
        <GraficoRespondids class="m-2"/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="d-flex align-items-center mb-2">
          <h5 class="mb-0 mr-3">Operadores</h5>
          <div class="form-group mb-0">
            <label for="activeFilter" class="small mb-1">Status de Login</label>
            <select id="activeFilter" v-model="activeFilter" class="form-control form-control-sm">
              <option value="*">Todos</option>
              <option value="b_ativo">Disponível</option>
              <option value="c_deslogado">Deslogado</option>
              <option value="a_em_atendimento">Atendimento</option>
            </select>
          </div>
        </div>
        <TbUsers ref="tbUsers" :filter="activeFilter" />
      </div>

      <div class="col-md-4">
        <GraficoOcupacaoAgent/>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import TbUsers from "./components/TbUsers";
import GraficoRespondids from "./components/GraficoRespondids";
import GraficoOcupacaoAgent from "./components/GraficoOcupacaoAgent";
import TbFilaAtendimento from "./components/TbFilaAtendimento";
import RealtimeAttendancesCount from "./components/RealtimeAttendancesCount";
import RealtimePhone from "./RealtimePhone.vue";
import TbFilaURA from "./components/TbFilaURA";
import TbFilaAndamento from "./components/TbFilaAndamento";
import TbFilaDetail from "./components/TbFilaDetail";
import ModalTransferencia from "../../components/newScreen/mensagem/ModalTransferencia.vue";
import socket from "./../../modules/realtime/service/service"; 

export default {
  name: "RealtimeApp",
  data() {
    return {
      toogleRealtime: true,
      intervalId: null,
      cl: "toogle",
      _onConnect: null,
      _unsubStore: null,
      hasJoinedRealtime: false, 
      activeFilter: "*",
      dadoClient: "",
      chatbotQueues: [],
      aguardandoQueues: [],
      emAtendimentoQueues: [],
      userChatQueues: [],
      _onQueueUra: null,
      _onQueueAwait: null,
      _onQueueAttend: null,
    };
  },
  created() {
    this.intervalId = setInterval(() => {
      this.toogleRealtime = !this.toogleRealtime;
    }, 15000);

    axios.get("/user-chat-queues").then(({ data }) => {
      this.userChatQueues = Array.isArray(data) ? data.slice() : [];
      this.userChatQueues.push("entrante", "generica");
    });

    this._onQueueUra = (obj) => { this.chatbotQueues = obj?.queues || []; };
    this._onQueueAwait = (obj) => { this.aguardandoQueues = obj?.queues || []; };
    this._onQueueAttend = (obj) => { this.emAtendimentoQueues = obj?.queues || []; };

    if (socket?.connection?.on) {
      socket.connection.on("queueUra", this._onQueueUra);
      socket.connection.on("queueAwait", this._onQueueAwait);
      socket.connection.on("queueAttend", this._onQueueAttend);
    }
  },
  mounted() {
    const getOperator = () =>
      this.$store?.getters?.getUser?.extension_line ??
      window?.ADVANCE?.operator ??
      null;

    const buildPayload = () => ({
      operator: getOperator(),
      href: window.location.href,
    });

    if (socket?.connection?.connected && !this.hasJoinedRealtime) {
      try {
        socket.connection.emit("realtime:join", buildPayload());
        this.hasJoinedRealtime = true;
      } catch (e) {}
    }

    this._onConnect = () => {
      if (!this.hasJoinedRealtime) {
        try {
          socket.connection.emit("realtime:join", buildPayload());
          this.hasJoinedRealtime = true;
        } catch (e) {}
      }
    };
    if (socket?.connection?.once) {
      socket.connection.once("connect", this._onConnect);
    } else if (socket?.connection?.on) {
      socket.connection.on("connect", this._onConnect);
    }

    this._unsubStore = this.$store?.subscribe?.((mutation, state) => {
      const op = getOperator();
      if (this.hasJoinedRealtime && op) {
        try {
          socket.connection.emit("realtime:identify", {
            operator: op,
            href: window.location.href,
          });
        } catch (e) {}
        if (this._unsubStore) {
          this._unsubStore();
          this._unsubStore = null;
        }
      }
    });
  },
  beforeDestroy() {
    try { socket.connection.emit("realtime:leave"); } catch (e) {}
    this.hasJoinedRealtime = false;

    const off = socket.connection?.off ? "off" : "removeListener";
    if (this._onConnect && socket?.connection?.[off]) {
      socket.connection[off]("connect", this._onConnect);
    }
    this._onConnect = null;

    if (this._unsubStore) { this._unsubStore(); this._unsubStore = null; }


    if (socket?.connection?.off) {
      if (this._onQueueUra)   socket.connection.off("queueUra", this._onQueueUra);
      if (this._onQueueAwait) socket.connection.off("queueAwait", this._onQueueAwait);
      if (this._onQueueAttend)socket.connection.off("queueAttend", this._onQueueAttend);
    } else if (socket?.connection?.removeListener) {
      if (this._onQueueUra)   socket.connection.removeListener("queueUra", this._onQueueUra);
      if (this._onQueueAwait) socket.connection.removeListener("queueAwait", this._onQueueAwait);
      if (this._onQueueAttend)socket.connection.removeListener("queueAttend", this._onQueueAttend);
    }
    this._onQueueUra = this._onQueueAwait = this._onQueueAttend = null;


    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods: {
    handleOpenModalTransf(cliente) {
      this.dadoClient = cliente;
      this.$refs.modalTrans.openModal();
    },
    setRT(style) {
      this.cl = style;
      if (this.intervalId) clearInterval(this.intervalId);

      if (style === "phone")  { this.toogleRealtime = true;  return; }
      if (style === "chat")   { this.toogleRealtime = false; return; }
      if (style === "toogle") {
        this.intervalId = setInterval(() => {
          this.toogleRealtime = !this.toogleRealtime;
        }, 15000);
      }
    },
  },
  computed: {
    chatbot() {
      return this.chatbotQueues.filter(q => this.userChatQueues?.includes(q.queue)).length;
    },
    aguardando() {
      return this.aguardandoQueues.filter(q => this.userChatQueues?.includes(q.queue)).length;
    },
    emAtendimento() {
      return this.emAtendimentoQueues.filter(q => this.userChatQueues?.includes(q.queue)).length;
    },
    total() {
      return this.chatbot + this.aguardando + this.emAtendimento;
    },
  },
  components: {
    TbFilaAtendimento,
    TbFilaURA,
    TbFilaAndamento,
    TbFilaDetail,
    GraficoOcupacaoAgent,
    GraficoRespondids,
    TbUsers,
    RealtimePhone,
    ModalTransferencia,
    RealtimeAttendancesCount,
  },
};
</script>

<style scoped>
.toogle-el{ display:none; }
.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.cards-summary {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.cards-summary .card {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.cards-summary .card h3 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #333;
}
.cards-summary .card p {
  font-size: 1.2rem;
  font-weight: bold;
  color: #555;
}
</style>
